var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 194",
    d: "M2.1 3.6H12.9V14C12.9 14.7732 12.2732 15.4 11.5 15.4H3.5C2.7268 15.4 2.1 14.7732 2.1 14V3.6Z",
    stroke: "#9FA6B2",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 195",
    d: "M4.98387 1.5741C5.22102 1.0998 5.70579 0.800195 6.23607 0.800195H8.76393C9.29421 0.800195 9.77898 1.0998 10.0161 1.5741L11.0292 3.6002H3.97082L4.98387 1.5741Z",
    stroke: "#9FA6B2",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 195_2",
    y: 3,
    width: 15,
    height: 1.2,
    rx: 0.6,
    fill: "#9FA6B2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 196",
    x: 8.09961,
    y: 6,
    width: 7,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(90 8.09961 6)",
    fill: "#9FA6B2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 198",
    x: 10.6992,
    y: 6,
    width: 7,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(90 10.6992 6)",
    fill: "#9FA6B2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 197",
    x: 5.69922,
    y: 6,
    width: 7,
    height: 1.2,
    rx: 0.6,
    transform: "rotate(90 5.69922 6)",
    fill: "#9FA6B2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f9ce6d090d29ffae0d447a49a65346bd.svg";
export { ForwardRef as ReactComponent };